export default {"src":"/_next/static/media/quote-blue.25d4b305.svg","height":150,"width":154};